import React from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

/** @deprecated Use the 'next' icon from the components library instead */
const IconArrowRight = props => (
  <svg viewBox="0 0 12 21" aria-hidden {...props}>
    <title>Arrow Right Icon</title>
    <path d="M11.246 10.287a1.942 1.942 0 0 0-.465-1.083L3.726 1.029a1.967 1.967 0 0 0-3.384.59A1.937 1.937 0 0 0 .75 3.56l5.964 6.91L.75 17.38c-.482.525-.639 1.268-.408 1.941s.812 1.167 1.516 1.289a1.968 1.968 0 0 0 1.868-.7l7.054-8.175c.347-.4.515-.923.466-1.448z" />
  </svg>
);

export default IconArrowRight;
